import React from 'react'

import {
    Box,
    Flex,
    Heading,
    Text,
    Image,
    useColorMode,
  } from "@chakra-ui/react";

  import {
    NavLink,
  } from "react-router-dom";

  import ThemeToggle from "./ThemeToggle";
  import AppMenu from "./AppMenu";
  import logo from './res/logomwifi.png'

  import { quantityAtom } from './Atoms';
  import { useAtom } from 'jotai'
  
  const Header = () => {
    const { colorMode } = useColorMode();
  
    return (
      <Box
        as="header"
        width="100%"
        height={100}
        backgroundColor={colorMode === "light" ? "white" : "gray.700"}
        boxShadow="0px 4px 14px 1px rgba(0, 0, 0, 0.15);"
        position="fixed"
        top="0"
        zIndex={5}
      >
        <Flex align="center" maxWidth={800} margin="0 auto" padding={4}>
          <Box>
              <NavLink to="/">
                <Flex alignItems="center">
                  <Image
                    // width={[220, 60]}
                    boxSize="50px"
                    src={logo}
                    alt="Monastero WiFi"
                  />
  
                  <Box marginLeft={4}>
                    <Heading
                      as="h1"
                      fontSize={["1rem", "1.5rem"]}
                      fontWeight="600"
                    >
                        Monastero Wi-Fi
                    </Heading>
                    {/* <Text fontSize="0.75rem" fontWeight="400">
                      Biologico per scelta
                    </Text> */}
                  </Box>
                </Flex>
              </NavLink>
          </Box>
  
          <Box marginLeft="auto">
            <ThemeToggle />
            <AppMenu />      
          </Box>
        </Flex>
      </Box>
    );
  };
  
  export default Header;
